export default __webpack_public_path__ + "static/media/eth.e7d905bf.png";